import { render } from "./OrderType.vue?vue&type=template&id=12d35586&scoped=true"
import script from "./OrderType.vue?vue&type=script&lang=js"
export * from "./OrderType.vue?vue&type=script&lang=js"

import "./OrderType.vue?vue&type=style&index=0&id=12d35586&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d35586"]])

export default __exports__